import { LLM } from 'reactApp/modules/features/features.helpers';
import { ActionCategory, MessageCategory } from 'reactApp/ui/EditorLLM/EditorLLMDialog/types/EditorLlmDialog.types';

type selectOptions<T extends string> = Record<T, string>;

type actionOptions = selectOptions<ActionCategory>;

type scenarioOptions = selectOptions<MessageCategory>;

interface LLMFeature {
    hoverType: 'withText' | 'withHover';
    actionOptions: actionOptions;
    scenarioOptions: scenarioOptions;
    dialogTitle: string;
    buttonTitle: string;
    tooltipTitle: string;
    tooltipMessage: string;
    tooltipButtonText: string;
    welcomeMessage: string;
    inputPlaceholder: string;
}

const DEFAULT_VALUE: LLMFeature = {
    hoverType: 'withText',
    actionOptions: {} as actionOptions,
    scenarioOptions: {} as scenarioOptions,
    dialogTitle: 'MailGPT',
    buttonTitle: 'MailGPT',
    tooltipTitle: 'Привет, я MailGPT',
    tooltipMessage: 'Помогу написать разный \nтекст и придумать идеи',
    tooltipButtonText: 'Попробовать',
    welcomeMessage:
        'Привет! Я умею писать текст, придумывать идеи, составлять списки и разное другое. Выбирайте, что нужно сделать, и начнём',
    inputPlaceholder: 'Предложите текст',
};

export const llmFeature: LLMFeature = { ...DEFAULT_VALUE, ...LLM };
